import { Helmet } from "react-helmet-async";
import { BRAND } from "@/lib/api";

const DEFAULT_TITLE = "Explore HOA's | Nationwide HOA Rules, Fees & Restrictions Directory";
const DEFAULT_DESC = "Search HOA fees, pet rules, rental restrictions and amenities for neighborhoods across the United States.";

export const Seo = ({ title, description = DEFAULT_DESC, path, image = "/images/p5366406.jpg", jsonLd, noindex, type = "website", modified }) => {
  const origin = window.location.origin;
  const url = `${origin}${path ?? window.location.pathname}`;
  const full = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
  const ld = jsonLd ? [].concat(jsonLd) : [];
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={`${origin}${image}`} />
      {modified && <meta property="article:modified_time" content={modified} />}
      {modified && <meta property="og:updated_time" content={modified} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${origin}${image}`} />
      {ld.map((j, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>
      ))}
    </Helmet>
  );
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${window.location.origin}${it.to}` })),
});
